"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconChevronDown = _interopRequireDefault(require("./IconChevronDown"));
var IconChevronRight = /*#__PURE__*/(0, _styledComponents.default)(_IconChevronDown.default).withConfig({
  displayName: "IconChevronRight",
  componentId: "c11n-8-107-0__sc-19mpgrq-0"
})(["transform:rotate(270deg);"]);
var _default = IconChevronRight;
exports.default = _default;